import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PageableModel } from 'src/app/modules/shared/models/pageable.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrudService<T> {

  constructor(private http: HttpClient) { }

  getPage(resource: string, page: number = 0, size: number = 10, sort: string, filters: any, custom = {}): Observable<PageableModel<T>> {
    return this.http.get<any>(`${environment.api.url}/api/v1/${resource}/?page=${page}&size=${size}&sort=${sort}&filters=${encodeURI(JSON.stringify(filters))}&custom=${encodeURI(JSON.stringify(custom))}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((body) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  count(resource: string, filters: any, custom = {}): Observable<number> {
    return this.http.get<any>(`${environment.api.url}/api/v1/${resource}/count/?filters=${encodeURI(JSON.stringify(filters))}&custom=${encodeURI(JSON.stringify(custom))}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((body) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  get(resource: string, id: number): Observable<T> {
    return this.http.get<any>(`${environment.api.url}/api/v1/${resource}/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((body) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  create(resource: string, data: T): Observable<T> {
    return this.http.post<any>(`${environment.api.url}/api/v1/${resource}`, data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((body) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  update(resource: string, id: string, data: T): Observable<T> {
    return this.http.put<any>(`${environment.api.url}/api/v1/${resource}/${id}`, data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((body) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  delete(resource: string, id: string): Observable<T> {
    return this.http.delete<any>(`${environment.api.url}/api/v1/${resource}/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((body) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  download(resource: string, page: number = 0, size: number = 10, sort: string, filters: any): Observable<any> {
    return this.http.get<any>(`${environment.api.url}/api/v1/${resource}/download?page=${page}&size=${size}&sort=${sort}&filters=${encodeURI(JSON.stringify(filters))}`, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      tap((body) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }
}
